//https://github.com/carvalhoviniciusluiz/cpf-cnpj-validator
import cpf from './cpf'
import cnpj from './cnpj'
import Joi from 'joi'

export { cpf, cnpj }

export function documentCleaner (value: string) {
  let document = cpf.strip(value)
  return cnpj.strip(document)
}

export function documentValidator (value: string) {

  const document = documentCleaner(value)
  if (!document)
    return false

  if (document.length <= 11)
    return cpf.isValid(document)

  if (document.length > 11)
    return cnpj.isValid(document)
}

export const validator = (joi: any) => ({
  type: 'document',
  base: joi.string(),
  messages: {
    'document.cpf': 'CPF inválido',
    'document.cnpj': 'CNPJ inválido'
  },
  rules: {
    cpf: {
      validate (value: any, helpers: any, args: any, options: any) {
        if (!cpf.isValid(value)) {
          return helpers.error('document.cpf');
        }

        return value
      }
    },
    cnpj: {
      validate (value: any, helpers: any, args: any, options: any) {
        if (!cnpj.isValid(value)) {
          return helpers.error('document.cnpj');
        }

        return value
      }
    }
  }
});

export default validator;
